import { api } from "./http";

export const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
export const passwordRegexErrorMessage =
  "Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character";

export async function logout() {
  await api.auth.post("users/logout");
}
